import dayjs from "dayjs";
import _ from "lodash";

import { SplitChannels } from "app/pages/website-analysis/traffic-sources/mmx/components/common/MobileSplit-utils";

export const trafficSources = {
    Direct: {
        title: "utils.direct",
        priority: 0,
        primaryKey: "Direct",
    },
    direct: {
        title: "utils.direct",
        priority: 0,
        primaryKey: "Direct",
    },
    OrganicSearch: {
        title: "utils.organic",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;0",
        priority: 1,
        icon: "search",
        isDesktopOnly: false,
        primaryKey: "Organic Search",
    },
    "Search - Organic": {
        title: "utils.search.organic",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;0",
        priority: 1,
        icon: "search",
        isDesktopOnly: false,
        primaryKey: "Organic Search",
    },
    searchOrganic: {
        title: "utils.search.organic",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;0",
        priority: 1,
        icon: "search",
        isDesktopOnly: false,
        primaryKey: "Organic Search",
    },
    "Organic Search": {
        title: "utils.organic",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;0",
        priority: 1,
        icon: "search",
        isDesktopOnly: false,
        primaryKey: "Organic Search",
    },
    "Organic search": {
        title: "utils.organic",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;0",
        priority: 1,
        icon: "search",
        isDesktopOnly: false,
        primaryKey: "Organic Search",
    },
    PaidSearch: {
        title: "utils.paid",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;1",
        priority: 2,
        icon: "paid-search",
        isDesktopOnly: false,
        primaryKey: "Paid Search",
    },
    "Search - Paid": {
        title: "utils.search.paid",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;1",
        priority: 2,
        icon: "paid-search",
        isDesktopOnly: false,
        primaryKey: "Paid Search",
    },
    searchPaid: {
        title: "utils.search.paid",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;1",
        priority: 2,
        icon: "paid-search",
        isDesktopOnly: false,
        primaryKey: "Paid Search",
    },
    "Paid Search": {
        title: "utils.paid",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;1",
        priority: 2,
        icon: "paid-search",
        isDesktopOnly: false,
        primaryKey: "Paid Search",
    },
    "Paid search": {
        title: "utils.paid",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "Keywords_filters=OP;%3D%3D;1",
        priority: 2,
        isDesktopOnly: false,
        icon: "paid-search",
    },
    Search: {
        title: "utils.Search",
        directory: "search",
        state: "digitalsuite_website_search_overview",
        queryParams: "selectedTab=overview",
        priority: 3,
        icon: "search",
        isMobileWebOnly: true, //Used In mmx mobile web
        primaryKey: "Search",
    },
    Referrals: {
        title: "utils.referrals",
        directory: "referrals",
        state: "digitalsuite_website_referrals_incomingtraffic",
        priority: 4,
        primaryKey: "Referrals",
    },
    referrals: {
        title: "utils.referrals",
        directory: "referrals",
        state: "digitalsuite_website_referrals_incomingtraffic",
        priority: 4,
        primaryKey: "Referrals",
    },
    DisplayAds: {
        title: "utils.displayads",
        directory: "display",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 5,
        primaryKey: "Paid Referrals",
    },
    "Display Ads": {
        title: "utils.displayads",
        directory: "display",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 5,
        primaryKey: "Paid Referrals",
    },
    "Display ads": {
        title: "utils.displayads",
        directory: "display",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 5,
        primaryKey: "Paid Referrals",
    },
    displayAds: {
        title: "utils.displayads",
        directory: "display",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 5,
        primaryKey: "Paid Referrals",
    },
    "Paid Referrals": {
        title: "utils.displayads",
        directory: "display",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 5,
        primaryKey: "Paid Referrals",
    },
    Social: {
        title: "utils.social",
        directory: "social",
        state: "digitalsuite_website_social_overview",
        priority: 6,
        primaryKey: "Social",
    },
    "Social - Organic": {
        title: "utils.social.organic",
        directory: "social",
        state: "digitalsuite_website_social_overview",
        priority: 6,
        primaryKey: "Social",
    },
    socialOrganic: {
        title: "utils.social.organic",
        directory: "social",
        state: "digitalsuite_website_social_overview",
        priority: 6,
        primaryKey: "Social",
    },
    "Social - Paid": {
        title: "utils.social.paid",
        directory: "social",
        state: "digitalsuite_website_social_overview",
        priority: 7,
        primaryKey: "Social",
    },
    socialPaid: {
        title: "utils.social.paid",
        directory: "social",
        state: "digitalsuite_website_social_overview",
        priority: 7,
        primaryKey: "Social",
    },
    "Gen AI": {
        title: "utils.gen.ai",
        priority: 8,
        primaryKey: "Social",
    },
    genAi: {
        title: "utils.gen.ai",
        priority: 8,
        primaryKey: "Social",
    },
    Mail: {
        title: "utils.mail",
        priority: 9,
        primaryKey: "Mail",
    },
    Email: {
        title: "utils.mail",
        priority: 9,
        primaryKey: "Mail",
    },
    email: {
        title: "utils.mail",
        priority: 9,
        primaryKey: "Mail",
    },
    affiliates: {
        title: "utils.affiliates",
        priority: 10,
        primaryKey: "Affiliates",
    },
    Affiliates: {
        title: "utils.affiliates",
        priority: 10,
        primaryKey: "Affiliates",
    },
};

export const trafficSourcesForSegments = {
    ...trafficSources,
    internalReferrals: {
        title: "utils.internal.referrals",
        directory: "referrals",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 8,
        primaryKey: "Internal Referrals",
        tooltipKey: "utils.internal.referrals.tooltip",
    },
    "Internal Referrals": {
        title: "utils.internal.referrals",
        directory: "referrals",
        state: "digitalsuite_website_display_overview",
        icon: "display-ads",
        priority: 8,
        primaryKey: "Internal Referrals",
        tooltipKey: "utils.internal.referrals.tooltip",
    },
};

export const orderedTrafficSources = Object.entries(trafficSources)
    .sort(([_source1Name, source1Object], [_source2Name, source2Object]) => {
        return source1Object.priority - source2Object.priority;
    })
    .map(([sourceName]) => sourceName as keyof typeof trafficSources);

export const orderedTrafficSourcesForSegments = Object.entries(trafficSourcesForSegments)
    .sort(([_source1Name, source1Object], [_source2Name, source2Object]) => {
        return source1Object.priority - source2Object.priority;
    })
    .map(([sourceName]) => sourceName as keyof typeof trafficSourcesForSegments);

export const utils = {
    emptyFn: <T>(item: T) => item,

    manipulateCategories: (categories: FixmeType) => {
        const parents: Record<string, FixmeType> = {};
        let cats: FixmeType[] = [];
        _.forEach(categories, (category) => {
            if (!category.Name) {
                return;
            }
            const fs = category.Name.split("/");
            const parent = fs[0];
            const son = fs[1];
            parents[parent] = parents[parent] || {
                Name: parent,
                id: parent,
                Count: 0,
            };

            parents[parent].Count += category.Count;
            parents[parent].Sons = parents[parent].Sons || {};
            if (son) {
                parents[parent].Sons[son] = { id: son, Name: son, Count: category.Count };
            }
        });

        _.forEach(parents, (value) => {
            cats.push(value);
        });

        cats = _.sortBy(cats, (category) => category.Count * -1);

        _.forEach(cats, (category) => {
            if (category.Sons) {
                category.Sons = _.sortBy(category.Sons, (category: { Count: number }) => category.Count * -1);
            }
        });

        return cats;
    },

    bigNumber: (val: number) => {
        if (val < 250) {
            return val;
        }

        /*
         Round the value to make it look more aesthetic
         The chooses what to round(hundreds/thousands etc) based on the number of digits of the number
         */
        const p = Math.floor(Math.log(val) / Math.log(10));
        const r = p % 2 === 1 ? Math.pow(10, (p + 3) / 2) : 5 * Math.pow(10, (p + 2) / 2);
        return Math.round(val / r) * r;
    },

    /**
     * Formating ordered array of items
     *
     * @param {Object[]} array - reversed (desc) sorted items as array
     * @param {Number} maxRows - maximum items to include in result array
     * @param {Object} [options] - optional configuration (see available attributes in function body)
     *
     * @returns {Array} - containing the first items from array and summarizing the rest (others) as last item
     *
     */
    formatTopList: (array: FixmeType[], maxRows: number, options?: FixmeType) => {
        // input sanity checks
        if (!array || !array.length || !maxRows) {
            return [];
        }

        array = array.concat([]);

        options = Object.assign(
            {
                nameAttr: "Name",
                valueAttr: "Value",
                imgAttr: "ImageUrl",
                filterUnknown: true,
                othersLabel: "others",
                transformFunction: utils.emptyFn,
            },
            options,
        );

        // omit null and "unknown" values from array if options.filterUnknown is true
        if (options.filterUnknown) {
            array = _.filter(array, (item) => {
                if (item[options.nameAttr] && !item[options.nameAttr]) {
                    item[options.nameAttr] = "unknown";
                }
                if (typeof item[options.nameAttr] === "string") {
                    return (
                        item[options.nameAttr] &&
                        item[options.nameAttr].toLowerCase() !== "unknown" &&
                        item[options.nameAttr].toLowerCase() !== "other" &&
                        item[options.nameAttr].toLowerCase() !== "others"
                    );
                } else if (typeof item[options.nameAttr] === "number") {
                    return item[options.nameAttr] && item[options.nameAttr] > 0;
                }

                return false;
            });
        }

        if (!array.length) {
            return [];
        }

        const total = Math.round(_.reduce(array, (memo, el) => memo + el[options.valueAttr], 0) * 1000) / 1000;
        let length;

        if (array.length < maxRows || (array.length == maxRows && total === 1)) {
            length = array.length;
        } else if (array.length == maxRows) {
            length = array.length - 1;
        } else {
            length = maxRows - 1;
        }

        const othersSum = 1 - _.reduce(_.take(array, length), (memo, el) => memo + el[options.valueAttr], 0);

        if (othersSum > 0) {
            const item: FixmeType = {};
            item[options.nameAttr] = options.othersLabel;
            item[options.valueAttr] = othersSum;
            item[options.imgAttr] = "";
            array.splice(length, array.length - length, item);
        }

        _.forEach(array, (item) => {
            options.transformFunction(item, options.filter);
        });

        return array;
    },

    volumesAndSharesSplited: {
        //    color: '#4485B1',
        order: trafficSources,
        sort: (source: FixmeType) => {
            const reservedLength = (utils.volumesAndSharesSplited.reservedPrioritiesLength =
                    utils.volumesAndSharesSplited.reservedPrioritiesLength ||
                    _.keys(utils.volumesAndSharesSplited.order).length),
                order = utils.volumesAndSharesSplited.order,
                // @ts-ignore FIXME: strict migration - Element implicitly has 'any' type because expression of type 'any' can't be used to index type 'typeof trafficSources' — source shape is unknown to this utility
                key = order[source.key] || order[source.name];
            return (key || { priority: reservedLength }).priority;
        },
        reservedPrioritiesLength: 0,
    },

    addCategoryIdFromName: (item: FixmeType, filter: FixmeType) => {
        const id = item.Name.replace("/", "~");
        if (id === filter) {
            delete item.Id;
            return;
        }
        item.Id = id;
    },

    formatKeyValue: (arr: FixmeType[]) =>
        _.map<any, [string, number]>(arr, (item: { Name: string; Value: number }) => [item.Name, item.Value]),

    /**
     * Uses canvas to convert from URL to Base64 image
     *
     * @see http://stackoverflow.com/questions/22172604/convert-image-url-to-base64
     * @param imageElement
     *
     *  */
    getBase64Image: (imageElement: FixmeType) => {
        const canvas = document.createElement("canvas");
        canvas.width = imageElement.width;
        canvas.height = imageElement.height;
        const ctx = canvas.getContext("2d");
        // @ts-ignore FIXME: strict migration - 'ctx' is possibly 'null' — legacy code assumes 2d context is always available on a freshly-created canvas
        ctx.drawImage(imageElement, 0, 0);
        const dataURL = canvas.toDataURL("image/png");
        return dataURL;
    },
    fillMissingTrafficSources: (data: FixmeType, isMobile: boolean, from: string, shouldRemoveSplit = false) => {
        const changedFormat = from.replaceAll("|", "-");
        const isDurationAfter6_2020 = dayjs(changedFormat).isAfter(SplitChannels.JUNE2020);
        const modifiedData = { ...data };
        // preparing desktop OR mobile trafficSources array
        const trafficSourcesDictionary = Object.keys(trafficSources)
            .filter((trafficSourceKey) => {
                const prop = isMobile ? "isDesktopOnly" : "isMobileWebOnly";
                // @ts-ignore FIXME: strict migration - heterogeneous trafficSources entries don't all expose isDesktopOnly/isMobileWebOnly — undefined is the intended "false" for those
                return !trafficSources[trafficSourceKey][prop];
            })
            .reduce<Record<string, FixmeType>>(
                // @ts-ignore FIXME: strict migration - indexing trafficSources by string literal key — preserving legacy lookup
                (res, trafficSourceKey) => ((res[trafficSourceKey] = trafficSources[trafficSourceKey]), res),
                {},
            );
        // iterating over the response traffic-sources
        Object.entries(modifiedData).forEach(([domain, value]: [string, FixmeType]) => {
            const domainTrafficSources = value["trafficSources"];
            if (domain !== "category") {
                const modifiedTrafficSources: Record<string, FixmeType> = {};
                // iterating over the available traffic-sources and copy each traffic-source from server to modifiedTrafficSources object
                for (const trafficSourceKey in trafficSourcesDictionary) {
                    const primaryTrafficSourceKey = trafficSourcesDictionary[trafficSourceKey]["primaryKey"];
                    // in case the response contains the trafficSource
                    if (domainTrafficSources[trafficSourceKey]) {
                        // add the trafficSource to modifiedTrafficSources object
                        modifiedTrafficSources[primaryTrafficSourceKey] = domainTrafficSources[trafficSourceKey];
                    } else if (!modifiedTrafficSources.hasOwnProperty(primaryTrafficSourceKey)) {
                        if (primaryTrafficSourceKey) {
                            modifiedTrafficSources[primaryTrafficSourceKey] = 0;
                        }
                    }
                }
                if (shouldRemoveSplit) {
                    if (isDurationAfter6_2020) {
                        delete modifiedTrafficSources[SplitChannels.SEARCH];
                    } else {
                        delete modifiedTrafficSources[SplitChannels.ORGANIC_SEARCH];
                        delete modifiedTrafficSources[SplitChannels.PAID_SEARCH];
                    }
                    modifiedData[domain].totalVisits = Object.values<number>(modifiedTrafficSources).reduce(
                        (sum: number, val) => sum + val,
                    );
                }
                modifiedData[domain].trafficSources = { ...modifiedTrafficSources };
            }
        });
        return modifiedData;
    },
    fillMissingTrafficForMMXPage: (data: FixmeType, isMobile: boolean, from: string, shouldRemoveSplit = false) => {
        const changedFormat = from.replaceAll("|", "-");
        const isDurationAfter6_2020 = dayjs(changedFormat).isAfter(SplitChannels.JUNE2020);
        let modifiedData = { ...data };
        // preparing desktop OR mobile trafficSources array
        const trafficSourcesDictionary = Object.keys(trafficSources)
            .filter((trafficSourceKey) => {
                const prop = isMobile ? "isDesktopOnly" : "isMobileWebOnly";
                // @ts-ignore FIXME: strict migration - heterogeneous trafficSources entries don't all expose isDesktopOnly/isMobileWebOnly — undefined is the intended "false" for those
                return !trafficSources[trafficSourceKey][prop];
            })
            .reduce<Record<string, FixmeType>>(
                // @ts-ignore FIXME: strict migration - indexing trafficSources by string literal key — preserving legacy lookup
                (res, trafficSourceKey) => ((res[trafficSourceKey] = trafficSources[trafficSourceKey]), res),
                {},
            );
        // iterating over the response traffic-sources
        isMobile
            ? (modifiedData = utils.removeChannels(
                  modifiedData,
                  trafficSourcesDictionary,
                  shouldRemoveSplit,
                  isDurationAfter6_2020,
              ))
            : Object.entries(modifiedData).forEach(([domain, value], index) => {
                  if (domain === "category") {
                      // eslint-disable-next-line no-self-assign
                      modifiedData["category"] = modifiedData["category"];
                  } else {
                      modifiedData[index] = utils.removeChannels(
                          modifiedData[index],
                          trafficSourcesDictionary,
                          shouldRemoveSplit,
                          isDurationAfter6_2020,
                      );
                  }
              });
        return modifiedData;
    },
    removeChannels: (
        data: FixmeType,
        trafficSourcesDictionary: FixmeType,
        shouldRemoveSplit: boolean,
        isDurationAfter6_2020: boolean,
    ) => {
        Object.entries(data).forEach(([domain, value]: [string, FixmeType]) => {
            const domainTrafficSources = value["trafficSources"];
            const modifiedTrafficSources: Record<string, FixmeType> = {};
            // iterating over the available traffic-sources and copy each traffic-source from server to modifiedTrafficSources object
            for (const trafficSourceKey in trafficSourcesDictionary) {
                const primaryTrafficSourceKey = trafficSourcesDictionary[trafficSourceKey]["primaryKey"];
                // in case the response contains the trafficSource
                if (domainTrafficSources[trafficSourceKey]) {
                    // add the trafficSource to modifiedTrafficSources object
                    modifiedTrafficSources[primaryTrafficSourceKey] = domainTrafficSources[trafficSourceKey];
                } else if (!modifiedTrafficSources.hasOwnProperty(primaryTrafficSourceKey)) {
                    if (primaryTrafficSourceKey) {
                        modifiedTrafficSources[primaryTrafficSourceKey] = 0;
                    }
                }
            }
            if (shouldRemoveSplit) {
                if (isDurationAfter6_2020) {
                    delete modifiedTrafficSources[SplitChannels.SEARCH];
                } else {
                    delete modifiedTrafficSources[SplitChannels.ORGANIC_SEARCH];
                    delete modifiedTrafficSources[SplitChannels.PAID_SEARCH];
                }
                data[domain].totalVisits = Object.values<number>(modifiedTrafficSources).reduce(
                    (sum, val) => sum + val,
                );
            }
            data[domain].trafficSources = { ...modifiedTrafficSources };
        });
        return data;
    },
};

export default utils;

const sw = (window["similarweb"] = window["similarweb"] || {});
sw.utils = utils;
